/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deleteaccount1Inputs */

const en_deleteaccount1 = /** @type {(inputs: Deleteaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Account`)
};

const de_deleteaccount1 = /** @type {(inputs: Deleteaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto löschen`)
};

/**
* | output |
* | --- |
* | "Delete Account" |
*
* @param {Deleteaccount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const deleteaccount1 = /** @type {((inputs?: Deleteaccount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deleteaccount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deleteaccount1(inputs)
	return de_deleteaccount1(inputs)
});
export { deleteaccount1 as "deleteAccount" }